import { IGenericModelFields } from "./IGenericFields";

export enum LibraryRecentSearchScope {
    PRESENTATION_LIBRARY = "presentation-library",
    TEAM_ASSETS = "team-assets",
    TEAM_SLIDES = "team-slides",
    TEAM_TEMPLATES = "team-templates",
    STARTER_TEMPLATES = "starter-templates",
}

export interface IAuthUser {
    id: string;
    uid: string;
    email: string;
    emailVerified: boolean;
    displayName: string;
    photoURL: string;
}

export interface IUser extends IGenericModelFields {
    createdAt: number;
    modifiedAt: number;
    lastSignedInAt: number;
    lastActive: number;

    // general info
    email: string;
    emailToBeVerified: string | null;
    firstName: string;
    lastName: string;
    company: string;
    provider: string;
    messagesSeen: Record<string, boolean>;
    presentationSort: string;
    presentationNotificationsSettings: any;
    pptFontsMap: any;
    cancelPlanSurvey: any;
    librarySettings: any;
    searchKeys: {
        [workspaceId: string]: {
            [privateApiKeyName: string]: string;
        };
    };
    userInfo: any;
    teamMigration: any;
    trialEndsTimestamp: number;
    workspaceRoleChange: any;
    workspaceDeleted: boolean;
    recentWorkspaceId?: string | null;
    organizationId: string;
    organizatinRole: string;
    firstPresentationId: string;
    trackUsageData: boolean;
    provisioning?: {
        sourceId: string;
        sourceMetadata: {
            sid: string,
            [key: string]: any
        };
    };
    partnerStackAttribution?: {
        clickId: string;
        partnerKey?: string | null;
        status: "pending" | "consumed";
        capturedAt: number;
        consumedAt?: number | null;
        workspaceId?: string | null;
    };
    /**
     * Tracks the checkout session ID that finalized the upgrade for each workspace
     */
    finalizedCheckoutSessions?: {
        [workspaceId: string]: {
            sessionId: string;
            subscriptionId: string;
        };
    };

    // random flags
    active: boolean;
    admin: boolean;
    isApiEnabled: boolean;
    didConfirmPlan: boolean;
    forcedWorkspaceDowngrade: boolean;
    forcedWorkspaceRemoval: string;
    hasTakenTour: boolean;
    hasTakenTeamTrial: boolean | number;
    hasUsedPPTAddin: boolean;
    ignoreSpellcheck: boolean;
    ignoreFontWarning: boolean;
    uiTheme: string;
    notifyByEmail: boolean;
    notifyWithPopup: boolean;
    _migrated: boolean;
    // viewedXX ones are not used anymore, so delete after confirming
    viewedCreateTeam: boolean;
    viewedManageLibrarySlides: boolean;
    viewedManageTeam: boolean;
    _changeId: string;
    edu: {
        eduStartDate: number;
    }

    // gdrive integration
    isGDriveEnabled: boolean;
    gDriveChannelId?: string;
    gDriveChannelExpiration?: number;

    // slack integration
    isSlackEnabled: boolean;
    slackBotUserId: string;
    slackChannelId: string;
    slackTeamId: string;
    slackTeamName: string;

    // resource references
    userFolders: { [userFolderId: string]: boolean } | { _changeId?: string, id?: string, modifiedAt?: number };
    user_themes: { [themeId: string]: boolean };

    // recent prompts
    recentPrompts: Record<"outline" | "chat", string[]>;

    // recent library search terms, keyed by scope
    recentLibrarySearches?: Partial<Record<LibraryRecentSearchScope, string[]>>;

    // quick start tasks progress
    quickStartTasks?: Record<string, boolean>;

    /**
     * Auth-specific flag used to track the last time the user's auth record was updated
     */
    authRecordUpdatedAt?: number;

    // legacy
    customerId?: string;
    stripeSubscriptionId?: string;
    subscriptionStatus?: string;
    forcedDowngrade?: boolean;
}

export interface IUserFolderFirebase {
    id: string;
    _changeId: string;
    userId: string;
    orgId?: string;
    name: string;
    presentations?: { // {  "0": "presentationId" }
        [key: string]: string;
    };
    subFolders?: {
        [key: string]: {
            id: string;
            name: string;
            presentations?: { // {  "0": "presentationId" }
                [key: string]: string;
            };
        };
    };
    createdAt: number;
    modifiedAt: number;
}
